import React from "react";

const SVG = ({
    style = {},
    fill = "#000",
    width = "10px",
    height = "17px",
    className = "",
    viewBox = "0 0 24 24"
}) => (
        <svg
            width={height}
            style={style}
            height={height}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            className={`svg-icon ${className || ""}`}
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill={fill}
                d="M13.7283745,20.159668 C16.2054252,20.159668 17.6063042,18.7773438 17.6063042,16.3837891 L17.6063042,15.3911133 L20.8069877,18.109375 C21.298687,18.5175781 21.7811088,18.7958984 22.2635307,18.7958984 C23.1448784,18.7958984 23.7571831,18.1743164 23.7571831,17.21875 L23.7571831,7.44970703 C23.7571831,6.48486328 23.1448784,5.86328125 22.2635307,5.86328125 C21.7718315,5.86328125 21.298687,6.14160156 20.8069877,6.55908203 L17.6063042,9.27734375 L17.6063042,8.20117188 C17.6063042,5.79833984 16.2054252,4.42529297 13.7283745,4.42529297 L4.11704634,4.42529297 C1.71421431,4.42529297 0.239116655,5.79833984 0.239116655,8.20117188 L0.239116655,16.4951172 C0.239116655,18.8886719 1.63999556,20.159668 4.11704634,20.159668 L13.7283745,20.159668 Z M13.3851127,18.2670898 L4.46030806,18.2670898 C3.05942915,18.2670898 2.26157759,17.5063477 2.26157759,16.0776367 L2.26157759,8.50732422 C2.26157759,7.03222656 3.05942915,6.30859375 4.46030806,6.30859375 L13.3851127,6.30859375 C14.7859917,6.30859375 15.5838432,7.06933594 15.5838432,8.50732422 L15.5838432,16.0776367 C15.5838432,17.5063477 14.767437,18.2670898 13.3851127,18.2670898 Z M21.7068901,16.4765625 C21.6326713,16.4765625 21.5770073,16.4301758 21.5027885,16.3745117 L17.6063042,13.2202148 L17.6063042,11.4482422 L21.5027885,8.28466797 C21.5770073,8.21972656 21.6326713,8.18261719 21.7068901,8.18261719 C21.8089409,8.18261719 21.8553276,8.25683594 21.8553276,8.37744141 L21.8553276,16.2817383 C21.8553276,16.4023438 21.8089409,16.4765625 21.7068901,16.4765625 Z" 
            />
        </svg>
    );

export default SVG;
